import { Mapper } from 'src/base/mapper'
import { InvoiceDataTableTypeEntity } from 'src/data/entities/invoice.entity'
import { InvoiceDataTableTypeModel } from 'src/domain/models/invoice.model'

export class InvoiceDataTableMapper extends Mapper<InvoiceDataTableTypeEntity, InvoiceDataTableTypeModel> {
	mapFrom(param: InvoiceDataTableTypeEntity): InvoiceDataTableTypeModel {
		return {
			invoiceId: param.invoiceId,
			invoiceNumber: param.invoiceNumber,
			totalAmount: param.totalAmount,
			companyName: param.companyName,
			clientId: param.clientId,
			status: param.status,
			dateDue: param.dateDue,
			isInD365: param.isInD365,
			isInD365error: param.isInD365error,
		}
	}

	mapTo(param: InvoiceDataTableTypeModel): InvoiceDataTableTypeEntity {
		return {
			invoiceId: param.invoiceId,
			invoiceNumber: param.invoiceNumber,
			totalAmount: param.totalAmount,
			companyName: param.companyName,
			clientId: param.clientId,
			status: param.status,
			dateDue: param.dateDue,
			subscriptionId: null,
			subscriptionName: null,
			statusName: null,
			isInD365: param.isInD365,
			isInD365error: param.isInD365error,
		}
	}
}
